export enum BALANCE_TYPE {
    NORMAL_BALANCE = 1,
    DISCOUNT_BALANCE,
}
